import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCorteExternoCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_CORTE_EXTERNO = process.env.REACT_APP_URL_ORDENES_CORTE_EXTERNO;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_ORDENES_CORTE_EXTERNO =  process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE_EXTERNO;
  const URL_ORDENES_CORTE_ACUMULADOS = process.env.REACT_APP_URL_ORDENES_CORTE_ACUMULADOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");  
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [value, setValue] = useState("");
  const [cliente, setCliente] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [fechaCompromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  // (2026-10) subárea del cliente (sale entre paréntesis junto al cliente)
  const [subArea, setSubArea] = useState("NA");
  const [corteExterno, setCorteExterno] = useState("Si");
  const [numero, setNumero] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);
    const [total_general, setTotalGeneral] = useState(0);

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [fecha_pedido, setFechaPedido] = useState("");
  const [total_piezas_pedido, setTotalPiezasPedido] = useState(0);
  const [total_general_pedido, setTotalGeneralPedido] = useState(0);

  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulosUnicos2, setArticulosUnicos2] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
     id: uuidv4(),
  cantidad: 0,
  idArticulosPedido: "",
  idArticulo: "",
  tc: [],
  arrayColoresArticulo: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_PEDIDOS}OrdenCorte`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPedidos = res.data;
        setPedidos(allPedidos);
      })
      .catch((err) => {
        console.log(err);
      });
       axios
      .get(`${URL_PROVEEDORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
// console.log("hola", inputFields);
const saveOrdenCorte = async (event) => {
  event.preventDefault();

  if (fecha === "") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan Datos",
    });
    return;
  }

  setValidaBoton(false);
  toggleProgreso();

  try {
    const { data } = await axios.post(
      URL_ORDENES_CORTE_EXTERNO,
      {
        fecha,
        fechaCompromiso,
        pedidos: selectedPedido,
        proveedores: selectedProveedor,
        cantidad: total_piezas,
        totalGeneral: total_general,
        observaciones,
        subArea: String(subArea || "").trim() || "NA",
        corteExterno,
        numero,
        cortado: "No",
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const mapaGuardado = new Map();

    inputFields.forEach((field) => {
      (field.tc || []).forEach((item) => {
        const cantidad = parseFloat(item.cantidad || 0);
        if (cantidad <= 0) return;

        const key = [
          String(item.idAreasClientes || ""),
          String(item.idArticulo || ""),
          String(item.idTalla || ""),
          String(item.idColor || ""),
        ].join("||");

        if (!mapaGuardado.has(key)) {
          mapaGuardado.set(key, {
            ordenesCorteExterno: data._id,
            cantidad,
            precio: parseFloat(item.precio) || 0,
            articulos: item.idArticulo,
            colores: item.idColor,
            tallas: item.idTalla,
            pendiente_cortar: cantidad,
            cortado: 0,
            pedidos: selectedPedido,
            areasClientes: item.idAreasClientes,
            // articulosPedido: Array.isArray(item.idArticulosPedido)
            //   ? item.idArticulosPedido[0] || ""
            //   : item.idArticulosPedido || "",
          });
        } else {
          const existente = mapaGuardado.get(key);
          existente.cantidad += cantidad;
          existente.pendiente_cortar += cantidad;
        }
      });
    });

    const registrosFinales = Array.from(mapaGuardado.values());

    if (registrosFinales.length === 0) {
      finalizarOrden(data._id, data.numero);
      return;
    }

    await Promise.all(
      registrosFinales.map((item) =>
        axios.post(URL_ARTICULOS_ORDENES_CORTE_EXTERNO, item, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
      )
    );

    finalizarOrden(data._id, data.numero);
  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Error al crear la Orden de Producción",
      footer: `${error.response?.data || error.message}`,
    });
    setValidaBoton(true);
  }
};

// Función auxiliar para finalizar y registrar el log
const finalizarOrden = (id, numero) => {
  axios
    .post(
      URL_LOGS,
      {
        tipo: "Crear Orden de Produccion",
        detalle: `${id}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      Swal.fire("Good job!", `Creado con éxito, Orden Corte ${numero}`, "success");
      setTimeout(() => window.location.reload(), 1000);
    })
    .catch((error) => {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al registrar el log",
        footer: `${error.response?.data || error.message}`,
      });
      setValidaBoton(true);
    });
};


  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
  cantidad: 0,
  idArticulosPedido: "",
  idArticulo: "",
  tc: [],
  arrayColoresArticulo: [],
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalMts = values.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  };

function BuscaArticulo(id, event) {
  const idArticuloSeleccionado = event.target.value;
  setIdArticulo(idArticuloSeleccionado);

  const articulosDelArticulo = articulosPedido.filter(
    (a) => String(a.idArticulo) === String(idArticuloSeleccionado)
  );

  if (articulosDelArticulo.length === 0) return;

  const colorMap = new Map();
  const coloresUnicos = [];

  articulosDelArticulo.forEach((a) => {
    if (!colorMap.has(String(a.idColor))) {
      colorMap.set(String(a.idColor), true);
      coloresUnicos.push({
        _id: a.idColor,
        name: a.color,
      });
    }
  });

  const agrupadoMap = new Map();

  articulosDelArticulo.forEach((a) => {
    const key = [
      String(a.idAreasClientes || ""),
      String(a.idArticulo || ""),
      String(a.idTalla || ""),
      String(a.idColor || ""),
    ].join("||");

    if (!agrupadoMap.has(key)) {
      agrupadoMap.set(key, {
        idArticulo: a.idArticulo,
        articuloNombre: a.articuloNombre,
        color: a.color,
        idColor: a.idColor,
        talla: a.talla,
        idTalla: a.idTalla,
        cantidad: parseFloat(a.cantidad) || 0,
        precio: parseFloat(a.precio) || 0,
        areasClientes: a.areasClientes,
        idAreasClientes: a.idAreasClientes,
        idArticulosPedido: a._id ? [a._id] : [],
      });
    } else {
      const existente = agrupadoMap.get(key);
      existente.cantidad =
        parseFloat(existente.cantidad || 0) + parseFloat(a.cantidad || 0);

      if (a._id) {
        existente.idArticulosPedido.push(a._id);
      }
    }
  });

  const combinaciones = Array.from(agrupadoMap.values());

  const total = combinaciones.reduce(
    (sum, a) => sum + parseFloat(a.cantidad || 0),
    0
  );
  setTotalPiezas(total);

  const nuevos = [...inputFields];
  const index = nuevos.findIndex((f) => f.id === id);

  if (index !== -1) {
    nuevos[index].idArticulo = idArticuloSeleccionado;
    nuevos[index].arrayColoresArticulo = coloresUnicos;
    nuevos[index].tc = combinaciones;
    setInputFields(nuevos);
  }

  handleChangeInputArticulo(id, idArticuloSeleccionado);
  ActualizaTotales(nuevos);
}

const handleChangePrecioPorColor = (fieldId, idColor, value) => {
  setInputFields((prevFields) => {
    const updatedFields = prevFields.map((field) => {
      if (field.id !== fieldId) return field;

      const nuevoPrecio = parseFloat(value) || 0;

      const updatedTc = (field.tc || []).map((item) => {
        if (String(item.idColor) === String(idColor)) {
          return {
            ...item,
            precio: nuevoPrecio,
          };
        }
        return item;
      });

      return {
        ...field,
        tc: updatedTc,
      };
    });

    ActualizaTotales(updatedFields);
    return updatedFields;
  });
};

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = idArticulo;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  // function ActualizaTotales() {
  //   let totalMts = articulosUnicos2.map((c) => parseFloat(c.cantidad));
  //   let TM = totalMts.reduce((t, total, index) => t + total, 0);
  //   setTotalPiezas(TM);
  // }

  function jalaPedido(e) {
    setSelectedPedido(e);

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosPedido = res.data;
        let arrayTabla = allArticulosPedido.map((a) => {
  const talla = a.tallas?.[0];
  const variante = talla?.variantesTallas?.[0];
          return {
            _id: a._id,
            idArticulo: a.articulos[0]._id,
            articuloNombre: a.articulos[0].codigoCliente + " " + a.articulos[0].codigo + " " + a.articulos[0].descripcion,
            talla: talla ? `${talla.name}${variante?.name ? ' ' + variante.name : ''}` : "Sin Talla",
            idTalla: a.tallas[0]._id,
            color: a.colores[0].name,
            idColor: a.colores[0]._id,
            cantidad: a.cantidad,
            cantidadPedido: a.cantidad,
            areasClientes: a.areasClientes[0].name,
            idAreasClientes: a.areasClientes[0]._id,
            // sucursales: a.sucursales[0].alias,
            // idSucursales: a.sucursales[0]._id,
            idArticulosPedido: a._id,
          };
        });
        let dataFinal = Object.values(arrayTabla);
        setArticulosPedido(dataFinal);
        setIdArticulo(dataFinal[0].idArticulo);

        let totalMts = dataFinal.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);

      })
      .catch((err) => {
        console.log(err);
      });

    pedidos.map((a) => {
      if (a._id == e) {
        setFechaPedido(a.fecha_cancelacion);
        setTotalPiezasPedido(a.total_piezas);
        setTotalGeneralPedido(a.total_general);
        setCliente(a.clientes[0].nombre_comercial);
        setIdCliente(a.clientes[0]._id);
      }
    });

  }

const handleInputFieldChangeCantidad = (
  id,
  idColorOrField,
  idTallaOrValue,
  valueWrapper
) => {
  setInputFields((prevFields) => {
    const updatedFields = prevFields.map((field) => {
      if (field.id !== id) return field;

      const updatedField = { ...field };

      if (
        typeof valueWrapper === "object" &&
        valueWrapper !== null &&
        "value" in valueWrapper
      ) {
        const { value, idAreasClientes } = valueWrapper;
        const cantidad = parseFloat(value) || 0;
        const idColor = idColorOrField;
        const idTalla = idTallaOrValue;

        updatedField.tc = (updatedField.tc || []).map((item) => {
          if (
            String(item.idColor) === String(idColor) &&
            String(item.idTalla) === String(idTalla) &&
            String(item.idAreasClientes) === String(idAreasClientes)
          ) {
            return { ...item, cantidad };
          }
          return item;
        });
      } else {
        const fieldName = idColorOrField;
        const value = idTallaOrValue;
        updatedField[fieldName] = value;
      }

      return updatedField;
    });

    ActualizaTotales(updatedFields);
    return updatedFields;
  });
};


const ActualizaTotales = (fields = inputFields) => {
  let totalPiezas = 0;
  let totalDinero = 0;

  fields.forEach((field) => {
    (field.tc || []).forEach((item) => {
      const cantidad = parseFloat(item.cantidad) || 0;
      const precio = parseFloat(item.precio) || 0;

      totalPiezas += cantidad;
      totalDinero += cantidad * precio;
    });
  });

  setTotalPiezas(totalPiezas);
  setTotalGeneral(parseFloat(totalDinero.toFixed(2)));
};


  const options = pedidos.map((option) => {
    const junta = option.idPedido + " " + option.clientes[0].nombre_comercial
    const firstLetter = option.idPedido.toString();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Orden de Compra</h3>
          <Form>
            <Row>
               <Col md={2}>
                <Label>Fecha Creacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  disabled
                  // required
                  // onChange={(e) => {
                  //   setFecha(e.target.value);
                  // }}
                />
              </Col> 
               <Col md={2}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="FechaCompromiso"
                  value={fechaCompromiso}
                  required
                  onChange={(e) => {
                    setFechaCompromiso(e.target.value);
                  }}
                />
              </Col> 
              <Col md={2}>
                              <Label className="mr-sm-2">Proveedor</Label>
                              <Input
                                className="col-sm-12"
                                type="select"
                                value={selectedProveedor}
                                required
                                onChange={(e) => {
                                  setSelectedProveedor(e.target.value);
                                }}
                              >
                                <option value="0">Selecciona un Proveedor</option>
                                {proveedores
                                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                                  .map((a) => {
                                      return <option value={a._id}>{a.nombre_comercial}</option>;
                                  })}
                              </Input>
                            </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Pedido</Label>
                <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedPedido) => {
                      if (selectedPedido) {
                        setValue(selectedPedido);
                        jalaPedido(selectedPedido._id);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.idPedido} {option.clientes[0].nombre_comercial}
                      </React.Fragment>
                    )}
                  />
              </Col>
              
              <Col md={2}>
                <Label>Cliente</Label>
                <Input
                  type="text"
                  placeholder="Cliente"
                  value={cliente}
                  required
                  disabled
                />
              </Col>
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Numero
                </Label>
                <Input
                  type="text"
                  placeholder="Numero"
                  value={numero}
                  required
                  onChange={(e) => {
                    setNumero(e.target.value);
                  }}
                />
              </Col> */}
              
             
            </Row>
            <Row>
            {/* <Col md={2}>
                <Label>Fecha Cancelacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_pedido}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaPedido(e.target.value);
                  }}
                />
              </Col> */}
              
              <Col md={3}>
                <Label className="mr-sm-2">Subárea</Label>
                <Input
                  type="text"
                  placeholder="Subárea"
                  value={subArea}
                  onChange={(e) => {
                    setSubArea(e.target.value);
                  }}
                />
              </Col>
              <Col md={5}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
               <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}
            <br />
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col> */}
            </Row>

{inputFields.map((inputField) => {
  const dataAgrupada = {};

  if (Array.isArray(inputField.tc)) {
    inputField.tc.forEach((item) => {
      const area = item.areasClientes || "Sin área";
      const articulo = item.articuloNombre || "Sin artículo";
      const color = item.color || "Sin color";

      if (!dataAgrupada[area]) dataAgrupada[area] = {};
      if (!dataAgrupada[area][articulo]) dataAgrupada[area][articulo] = {};
      if (!dataAgrupada[area][articulo][color]) {
        dataAgrupada[area][articulo][color] = [];
      }

      dataAgrupada[area][articulo][color].push(item);
    });
  }

  return (
    <div key={inputField.id} className="mb-4">
      <Row>
        <Col md={3}>
          <Input
            bsSize="sm"
            name="idArticulo"
            type="select"
            value={inputField.idArticulo}
            onChange={(event) => {
              BuscaArticulo(inputField.id, event);
            }}
          >
            <option value="">Selecciona un Articulo</option>
            {articulosUnicos
              .sort((a, b) =>
                a.articuloNombre > b.articuloNombre ? 1 : -1
              )
              .map((a) => (
                <option key={a.idArticulo} value={a.idArticulo}>
                  {a.articuloNombre}
                </option>
              ))}
          </Input>
        </Col>

        <Col>
          <Button
            size="sm"
            className="btn"
            color="danger"
            disabled={inputFields.length === 1}
            onClick={() => handleRemoveFields(inputField.id)}
            tabIndex="-1"
          >
            <i className="fas fa-minus"></i>
          </Button>
          <Button
            size="sm"
            className="btn"
            color="info"
            onClick={handleAddFields}
            tabIndex="-1"
          >
            <i className="fas fa-plus"></i>
          </Button>
        </Col>
      </Row>

      <br />

      {Object.entries(dataAgrupada).map(([area, articulos]) => (
        <div key={area} className="mb-4">
          <h5 style={{ fontWeight: "700", color: "#2f4f4f" }}>
            Área: {area}
          </h5>

          {Object.entries(articulos).map(([articuloNombre, colores]) => (
            <div key={articuloNombre} className="mb-4">
              <h6 style={{ fontWeight: "700", color: "#000" }}>
                {articuloNombre}
              </h6>

              {Object.entries(colores).map(([colorNombre, items]) => {
                const itemsOrdenados = [...items].sort((a, b) => {
                  const baseA = (a.talla || "").split(" ")[0];
                  const baseB = (b.talla || "").split(" ")[0];
                  const indexA = ordenTallas.indexOf(baseA);
                  const indexB = ordenTallas.indexOf(baseB);

                  return (
                    (indexA === -1 ? Infinity : indexA) -
                    (indexB === -1 ? Infinity : indexB)
                  );
                });

                const totalColor = itemsOrdenados.reduce(
                  (sum, item) => sum + (parseFloat(item.cantidad) || 0),
                  0
                );

                const precioColor = itemsOrdenados[0]?.precio || 0;

                return (
                  <div
                    key={`${area}_${articuloNombre}_${colorNombre}`}
                    className="mb-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      flexWrap: "wrap",
                      borderBottom: "1px solid #e9ecef",
                      paddingBottom: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      style={{
                        minWidth: "220px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "800",
                          fontSize: "18px",
                          color: "#557c55",
                          textTransform: "uppercase",
                        }}
                      >
                        {colorNombre}
                      </div>

                      <div
                        style={{
                          fontSize: "15px",
                          color: "#6c757d",
                          marginBottom: "8px",
                        }}
                      >
                        Total color:{" "}
                        <strong>
                          {new Intl.NumberFormat("en-US").format(totalColor)}
                        </strong>
                      </div>

                      <div className="d-flex align-items-center">
                        <span
                          style={{
                            color: "#555",
                            fontWeight: "500",
                            marginRight: "10px",
                          }}
                        >
                          Precio
                        </span>
                        <Input
                          bsSize="sm"
                          type="number"
                          step="0.01"
                          placeholder="Precio"
                          value={precioColor}
                          onChange={(e) =>
                            handleChangePrecioPorColor(
                              inputField.id,
                              itemsOrdenados[0]?.idColor,
                              e.target.value
                            )
                          }
                          style={{
                            width: "120px",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{
                        gap: "24px",
                        flex: 1,
                      }}
                    >
                      {itemsOrdenados.map((a) => (
                        <div
                          key={`${a.idAreasClientes}_${a.idArticulo}_${a.idTalla}_${a.idColor}`}
                          className="text-center"
                          style={{
                            minWidth: "88px",
                          }}
                        >
                          <Label
                            style={{
                              color: "#314a7d",
                              fontWeight: "600",
                              marginBottom: "6px",
                              display: "block",
                            }}
                          >
                            {a.talla}
                          </Label>

                          <Input
                            bsSize="sm"
                            type="number"
                            value={a.cantidad}
                            onChange={(event) =>
                              handleInputFieldChangeCantidad(
                                inputField.id,
                                a.idColor,
                                a.idTalla,
                                {
                                  value: event.target.value,
                                  idAreasClientes: a.idAreasClientes,
                                }
                              )
                            }
                            style={{
                              width: "84px",
                              textAlign: "center",
                              margin: "0 auto",
                              borderRadius: "10px",
                              border: "1px solid #ced4da",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
})}

<Button
      size="sm"
      className="btn"
      color="info"
      onClick={handleAddFields}
      tabIndex="-1"
    >
      <i className="fas fa-plus"></i>
    </Button>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}
          </Form>

          <br />
          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={saveOrdenCorte}
                >
                  Guardar
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="btn btn-success"
                  disabled
                  tabindex="-1"
                >
                  Guardar
                </Button>
              )}
              <Button
                href="/ListadoOrdenesCorteExterno"
                className="btn btn-danger"
                id="botonListado"
                tabindex="-1"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCorteExternoCreate;
